// Lodash
window._ = require('lodash');
// Slugify
window.slugify = require('slugify');
// Popper
require('@popperjs/core');
// Bootstrap
window.bootstrap = require('bootstrap');
// Toastr
window.toastr = require('toastr');
// common/app.js
require('../../common/js/app');
